import React,{useState,useEffect} from 'react'
import Select from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import RestService from "./../../Restservice";
import CustomTable from '../../component/CustomTable';

const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
    setSelect: {
      width: "150px",
      display: "inline-block",
      marginLeft: "10px", 
      marginBottom:'10px'
    }
  }));

export default function OptionScr(props) {
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const symbol = props?.symbol;
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";
  const [option, setoption] = useState("Long BuildUp");
  const [expdate, setExpdate] = useState(false);
  const [results, setResults] = useState(false);
  const classes = useStyles();
    
  const getOptionType = (value) => {
        setoption(value);
  };
    
  const getExpiryDate = (event) => {
        setExpdate(event.value);
         
  };

      useEffect(()=>{
        RestService.gethStockScreenerData(
            function (res,) {
                const response = JSON.parse(res); 
                setResults(response.data);
            },
            symbol,
            mobile,
            web_token,
            expdate,
            option
            
          );
      },[symbol,mobile,web_token,option,expdate])
  return (
     <>
        <div className="row mt-4">
                <div className="col-sm-11 option-chain-btn">
                {props.allDate && <Select
                 styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPosition={"fixed"}
                    onChange={getExpiryDate}
                    options={props.allDate ? props.allDate : []}
                    name="expiry_date"
                    className={classes.setSelect + " select-option"}
                  />
                }

                  <button className="btn mr-2 "> ||</button>

                  <button
                    onClick={(event) => getOptionType("Long BuildUp")}
                    className={
                      option === "Long BuildUp"
                        ? "btn btn-success mr-2"
                        : "btn btn-default mr-2"
                    }
                  >
                    Long BuildUp
                  </button>
                  <button
                    onClick={(event) => getOptionType("Short BuildUp")}
                    className={
                      option === "Short BuildUp"
                        ? "btn btn-success mr-2"
                        : "btn btn-default mr-2"
                    }
                  >
                    Short BuildUp
                  </button>
                  <button
                    onClick={(event) => getOptionType("Long Unwinding")}
                    className={
                      option === "Long Unwinding"
                        ? "btn btn-success mr-2"
                        : "btn btn-default mr-2"
                    }
                  >
                    Long Unwinding
                  </button>
                  <button
                    onClick={(event) => getOptionType("Short Covering")}
                    className={
                      option === "Short Covering"
                        ? "btn btn-success mr-2"
                        : "btn btn-default mr-2"
                    }
                  >
                    Short Covering
                  </button>
                </div>
                </div>
                {results.getDetails && results.setColumn && (
                    <>
                      <CustomTable
                        key={results?.setColumn.dataField}
                        columndata={results?.setColumn}
                        marketdata={results?.getDetails}
                        redirectlink="/stocks/"
                        pageSizeNumber="10"
                      />
                    </>
                  )}
     </>
  )
}
